import { get } from '../Services/http';
import { catchError } from './Error.action';
import {
    PRICE_FETCH,
    PRICE_LOAD_ERROR,
    PRICE_SET_ITEM,
    PRICE_SET_ACCESSORIES,
} from '../constants';

export const load = (accessories) => (dispatch, getState) => {
    const price = getState().price;

    let params = `?itemId=${price.itemId}`;
    
    if (accessories != null && accessories.length) {
        accessories.forEach(accessoryId => {
            if (accessoryId) {
                params += `&accessoryIds=${accessoryId}`;
            }
        });
    }
    
    return get(`/api/price${params}`)
        .then((response) => response.json())
        .then((price) => dispatch(receive(price)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
    type: PRICE_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (price) => ({
    type: PRICE_FETCH,
    payload: price,
});

export const setItem = (itemId) => ({
    type: PRICE_SET_ITEM,
    payload: {
        itemId
    }
});

export const setAccessories = (accessories) => ({
    type: PRICE_SET_ACCESSORIES,
    payload: {
        accessories: accessories
    }
});